import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';
import { HttpClient } from "@angular/common/http";
import { AppServiceHelperService } from "../../../../../services/app-service-helper.service";

/**
 * ValueConclusionTable Widget
 */
@Component({
  selector: 'value-conclusion-table-widget',
  templateUrl: './value-conclusion-table-widget.component.html',
  styleUrls: ['./value-conclusion-table-widget.component.scss', '../../common/css/general.scss']
})
export class ValueConclusionTableWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
 * HTTP client
 */
  public httpClient: HttpClient;

  /**
 * Data object
 */
  public data: any = { dateOfValue: '', valueConclusion: ''};

  /**
 * The server helper for getting API URLs
 */
  public appServiceHelper: AppServiceHelperService;

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.loadReflist('ref_l3_appraisal_premise');
    this.loadReflist('ref_l3_interest_appraised');

    this.mockupData$ = this.widgetService.loadMockup('valuationResults').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('valuationResults', this.getReport()).pipe();

    if (!this.mockup && this.getReport()) {
      const url = this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Reports?oid=${this.getReport()}`)
      this.httpClient.get(url).pipe(take(1)).subscribe({
        next: (result: any) => {
          this.data.dateOfValue = result.ValuationDate; //set dateOfValue
        },
        error: (error) => {
          alert(error);
        }
      });
    }
  }

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'valueConclusionTable', false);
    this.httpClient = injector.get(HttpClient);
    this.appServiceHelper = injector.get(AppServiceHelperService);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Pre-process the loaded data.Override if needed
   * @param data The loaded data
   */
  protected preprocessLoadedData(data): any {
    this.data.valueConclusion = data.reportValuationSayValue; //set valueConclusion
  }
}
